/**
 * BannerImage — artwork that never leaves a broken icon behind. When the
 * upload 404s (or none was set), we fall back to a branded FWM block carrying
 * the record's own name.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';

export const BannerFallback = ({ label, className = '', testId = 'banner-image', icon: Icon = Sparkles }) => (
  <div className={`relative overflow-hidden flex flex-col items-center justify-center gap-2 ${className}`}
       style={{ background: 'linear-gradient(135deg,#14110F 0%,#2A2118 58%,#8A6717 140%)' }}
       data-testid={`${testId}-fallback`}>
    <div className="absolute inset-0 opacity-[0.16] pointer-events-none"
         style={{ backgroundImage: 'radial-gradient(rgba(255,255,255,.4) 1px, transparent 1px)',
                  backgroundSize: '4px 4px' }} />
    <Icon className="h-5 w-5" style={{ color: '#D8B25A' }} />
    {label && (
      <p className="px-6 text-center text-sm font-semibold text-white/90 line-clamp-2">{label}</p>
    )}
    <p className="text-[10px] uppercase tracking-[0.28em] text-white/40">Faith Works Ministries</p>
  </div>
);

export const BannerImage = ({ src, alt, label, className = '', testId = 'banner-image', icon }) => {
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => setFailed(false), [src]);

  if (!src || failed) {
    return <BannerFallback label={label || alt} className={className} testId={testId} icon={icon} />;
  }
  return (
    <img src={src} alt={alt} loading="lazy" data-testid={testId} className={className}
         onError={() => setFailed(true)} />
  );
};

export default BannerImage;
